import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getGeoCoordinates } from '../../../selectors/newbuilding';
import { POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES } from '../../../constants/infrastructure';
import { EInsideTAInfrastructureType, TTAInfrastructureType } from '../../../types/map';
import { Map } from '@cian/frontend-newbuilding-map-component';
import { DEFAULT_MAP_CONFIG } from '../../../constants/map';

type TSetTransportAccessibilityZoomResult = {
  isZoomChanged: boolean;
  animationDelay: number;
};

const INSIDE_TAB_ZOOM = 17;
const OUTSIDE_TAB_ZOOM = DEFAULT_MAP_CONFIG.defaultZoom;
const ZOOM_ANIMATION_DELAY = 250;

export const useTransportAccessibilityZoom = (mapApi: Map | null) => {
  const pinCoordinates = useSelector(getGeoCoordinates);

  const setTransportAccessibilityZoom = useCallback(
    (infrastructureType: TTAInfrastructureType | null): TSetTransportAccessibilityZoomResult => {
      if (!pinCoordinates || !infrastructureType || !mapApi) {
        return {
          isZoomChanged: false,
          animationDelay: 0,
        };
      }

      const zoom = POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES.includes(infrastructureType as EInsideTAInfrastructureType)
        ? INSIDE_TAB_ZOOM
        : OUTSIDE_TAB_ZOOM;

      const currentZoom = mapApi.getZoom();

      mapApi.setCenterAndZoom(pinCoordinates, zoom, ZOOM_ANIMATION_DELAY);

      return {
        isZoomChanged: currentZoom !== zoom,
        animationDelay: ZOOM_ANIMATION_DELAY,
      };
    },
    [pinCoordinates, mapApi],
  );

  return {
    setTransportAccessibilityZoom,
  };
};
